import React, { useState } from "react";
import useLocationOptions from "app/popleads/hooks/useLocationOptions";
import Modal from "app/popleads/components/ui-kit/Modal";
import ExtensionInputGroup from "./ExtensionInputGroup";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import useSetUserSettings from "app/popleads/hooks/useSetUserSettings";
import { actions } from "app/modules/Auth/_redux/authRedux";
import { get } from "app/popleads/networking/RequestService";
import useGetCourseCategories from "app/popleads/hooks/useGetCourseCategories";

function ExtensionAIAssistantSettings({ isModalOpen, setIsModalOpen }) {
    const { user: loggedInUser } = useSelector((state) => state.auth);
    const dispatch = useDispatch();

    const aiAgentTargeting = loggedInUser.aiAgentTargeting ? JSON.parse(loggedInUser.aiAgentTargeting) : {};
    const [countries, setCountries] = useState(aiAgentTargeting.countries || []);
    const [portfolios, setPortfolios] = useState(aiAgentTargeting.portfolios || []);
    // const [academies, setAcademies] = useState(aiAgentTargeting.academies || []);

    const { countryOptions, isLoading: countryOptionsLoading } = useLocationOptions();
    const { courseCategories, isLoading: courseCategoriesLoading } = useGetCourseCategories();

    const { setUserSettings } = useSetUserSettings({
        onSuccess: async () => {
            toast.success("Settings updated successfully");
            const { data } = await get("getLoggedinUser");
            dispatch(actions.setUser(data.user));
            setIsModalOpen(false);
        },
        onError: (errorMessage) => {
            toast.error(errorMessage);
        },
    });

    const handleSave = () => {
        const updatedSettings = {
            ...aiAgentTargeting,
            countries,
            portfolios,
        };
        const updatedSettingsString = JSON.stringify(updatedSettings);
        setUserSettings({
            settingsKey: "aiAgentTargeting",
            settingsValue: updatedSettingsString,
        });
    };

    // const fetchQuery = async (inputValue, page, rowsPerPage) => {
    //     const requestObj = {
    //         fn: "campaignListHomePage",
    //         columnName: "Academy",
    //         rowsPerPage: rowsPerPage,
    //         start: page * rowsPerPage,
    //         columnValue: inputValue || null,
    //         isExport: 0,
    //         isTemplate: 1,
    //     };

    //     try {
    //         const response = await post(requestObj);
    //         const data = response.data;

    //         const options = data?.searchResults
    //             ?.filter((item) => item !== data?.count)
    //             .map((item) => ({
    //                 value: item,
    //                 label: item,
    //             }));

    //         return {
    //             options: options,
    //             hasMore: data.count ? page * rowsPerPage < Number(data.count) : false,
    //             additional: {
    //                 page: page + 1,
    //                 rowsPerPage: rowsPerPage,
    //             },
    //         };
    //     } catch (error) {
    //         return {
    //             options: [],
    //             hasMore: false,
    //             additional: {
    //                 page: 1,
    //                 rowsPerPage: rowsPerPage,
    //             },
    //         };
    //     }
    // };

    // const loadOptions = (inputValue, _, { page, rowsPerPage }) =>
    //     new Promise((resolve) => {
    //         const options = fetchQuery(inputValue, page, rowsPerPage);
    //         resolve(options);
    //     });

    return (
        <Modal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            title={"CAIN Targeting"}
            variant="l3rnTech"
            successButtonText="Save"
            cancelButtonText="Cancel"
            onSuccess={handleSave}
        >
            <div
                className="d-flex flex-column"
                style={{
                    width: "452px",
                    padding: "2px",
                    textAlign: "left",
                    gap: "16px",
                    overflowY: "scroll",
                    maxHeight: "70vh",
                }}
            >
                <ExtensionInputGroup
                    variant="l3rnTech"
                    type="select"
                    label="Countries"
                    placeholder="Select countries"
                    disabled={countryOptionsLoading}
                    options={countryOptions}
                    isMulti={true}
                    isClearable={true}
                    isSearchable={true}
                    value={countries}
                    onChange={(selection) => {
                        if (selection?.length > 10) {
                            toast.error("You've reached the maximum country selection (10).");
                            return;
                        }
                        setCountries(selection);
                    }}
                    menuPortalTarget={document.body}
                />
                <ExtensionInputGroup
                    variant="l3rnTech"
                    type="select"
                    label="Portfolios"
                    placeholder="Select portfolios"
                    disabled={courseCategoriesLoading}
                    options={courseCategories.map((category) => ({
                        value: category.id,
                        label: category.name,
                    }))}
                    isMulti={true}
                    isClearable={true}
                    isSearchable={true}
                    value={portfolios}
                    onChange={(selection) => {
                        if (selection?.length > 3) {
                            toast.error("You've reached the maximum portfolio selection (3).");
                            return;
                        }
                        setPortfolios(selection);
                    }}
                    menuPortalTarget={document.body}
                />
                {/* <ExtensionInputGroup
                    variant="l3rnTech"
                    type="select"
                    label="Academies"
                    placeholder="Select academies"
                    isMulti={true}
                    isClearable={true}
                    isSearchable={true}
                    value={academies}
                    // defaultOptions={[]}
                    onChange={(selection) => {
                        if (selection?.length > 3) {
                            toast.error("You've reached the maximum academy selection (3).");
                            return;
                        }
                        setAcademies(selection);
                    }}
                    loadOptions={loadOptions}
                    additional={{ page: 0, rowsPerPage: 10 }}
                    menuPortalTarget={document.body}
                /> */}
            </div>
        </Modal>
    );
}

export default ExtensionAIAssistantSettings;
